import React from 'react'
// CSS
import '../assets/css/metrics-card.css'

export default function MetricsCard(props) {
  return (
    <div className='metrics_card'>
      <div className='count'>
        <div></div>
        <span>{props.count}</span>
      </div>
      <div className='title'>{props.title}</div>
    </div>
  )
}
